import { render, staticRenderFns } from "./OrderSign.vue?vue&type=template&id=296b706d&scoped=true&"
import script from "./OrderSign.vue?vue&type=script&lang=js&"
export * from "./OrderSign.vue?vue&type=script&lang=js&"
import style0 from "./OrderSign.vue?vue&type=style&index=0&id=296b706d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b706d",
  null
  
)

export default component.exports